export const defaultConfig = {
    position: 'bottom-right',
    newestOnTop: true,
    draggablePercent: 50,
};
